/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { CollectionListMessage } from "../../../messages";
import {VApplication} from "../../../../../application";
import {AppNavigatorService} from "../../../../appNavigatorService";
import {toHeaderCase} from "js-convert-case";
const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};
const MODULE_NAME =
  "services.PortfolioListPageService.machines.GetCollectionList.state.formatCollectionChildren";
const log = LoggerModule?.getInstance();

export const formatCollectionChildren = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const msg = context?.input as CollectionListMessage;
      const user = await getWhoamiSrv()?.whoAmI();
      if (msg?.nodes?.data && msg?.collection?.collectionList) {
        for (const coll of msg?.nodes?.data) {
          msg.collection?.collectionList?.push({
            ...coll,
            id: coll?.uuid,
            title: toHeaderCase(coll?.name ?? ""),
            description: coll?.description,
            image: coll?.logo,
            catalogueType: "catalogue",
            startDate: coll?.metaData?.startDate,
            userType:user?.whoami,
            ribbon: coll?.exist ? {backgroundColor: "green",
            value: "Created"}:null
          });
        }
        msg.collection.totalCount = msg.nodes.totalCount;
        msg.collection.totalPages = msg.nodes.totalPages;
        msg.collection.currentPage = msg.nodes.currentPage;
      }
      return resolve(true);
    } catch (err: any) {
      log?.error(MODULE_NAME, "error in formatCollectionChildren", err);
      return reject(err?.message);
    }
  });
};
